import { lazy, Suspense } from 'react';

// Lazy load the ChatbotWidget component
const ChatbotWidget = lazy(() => import('./ChatbotWidget'));

interface ChatbotWidgetLazyProps {
  apiKey: string;
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
}

const ChatbotWidgetLazy: React.FC<ChatbotWidgetLazyProps> = ({ apiKey, position }) => {
  return (
    <Suspense fallback={null}>
      <ChatbotWidget apiKey={apiKey} position={position} />
    </Suspense>
  );
};

export default ChatbotWidgetLazy;
